module.exports = __webpack_public_path__ + "static/media/Product Pic-9.5cea343e.jpg";